import {
  afterNextRender,
  Component,
  ContentChildren,
  ElementRef,
  inject,
  Input,
  OnDestroy,
  QueryList,
  signal,
  TemplateRef,
  ViewChild
} from '@angular/core';
import EmblaCarousel, {EmblaCarouselType, EmblaOptionsType} from "embla-carousel";
import {MatButton} from "@angular/material/button";
import {DeviceService, IconComponent, IconKey} from "@gamergains/arcade";
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-carousel',
  imports: [
    MatButton,
    IconComponent,
    RouterLink
  ],
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss'
})
export class CarouselComponent implements OnDestroy {
  @ContentChildren(TemplateRef) templates!: QueryList<TemplateRef<any>>;

  @ViewChild('carouselViewport') carouselViewport: ElementRef;
  @ViewChild('leftButton') leftButton: MatButton;
  @ViewChild('rightButton') rightButton: MatButton;

  @Input() title: string | null;
  @Input() titleClass = 'ac-title-lg';
  @Input() iconKey: IconKey;
  @Input() slidesToScroll: 'auto' | number = 'auto';
  @Input() viewAllLink?: string;

  carousel: EmblaCarouselType;
  hideNavButtons = signal(false);

  device = inject(DeviceService);

  private readonly _options: EmblaOptionsType = { align: 'start', dragFree: true };

  constructor() {
    afterNextRender(() => {
      this.carousel = EmblaCarousel(this.carouselViewport.nativeElement, { ...this._options, slidesToScroll: this.slidesToScroll });

      this.carousel
        .on('select', this._toggleNavButtonStates)
        .on('init', this._toggleNavButtonStates)
        .on('reInit', this._toggleNavButtonStates);
    });
  }

  ngOnDestroy() {
    this.carousel?.destroy();
  }

  scrollLeft() {
    this.carousel.scrollPrev();
    this._toggleNavButtonStates();
  }

  scrollRight() {
    this.carousel.scrollNext();
    this._toggleNavButtonStates();
  }

  private _toggleNavButtonStates = () => {
    this.leftButton.disabled = !this.carousel.canScrollPrev();
    this.rightButton.disabled = !this.carousel.canScrollNext();

    this.hideNavButtons.set(this.leftButton.disabled && this.rightButton.disabled);
  }
}
